// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3fim1","fileBtn":"File_fileBtn__3MFYk","closeBtn":"File_closeBtn__yZjcv","fileSelected":"File_fileSelected__2MouP","disabled":"File_disabled__2PAuI"};